/* CM OPT03 · C2 (3-nov-2026). Reseñas del producto: 3 por página en la página (primero las que tienen foto o video),
   flechas y números de página, y «Ver las X reseñas» abre una ventana con todas, 5 por página, en el mismo orden.
   Datos: assets/cm-resenas-<id>.json (lista completa leída del widget de Loox, con sabor y traducción) + las 40 más
   recientes que Loox mantiene en Shopify (review_feed, en el HTML) para sumar las que llegaron después del archivo.
   Ver snippets/cm-resenas-bloque.liquid e implementaciones/nutri11-opt03-2026-11.md. */
(function () {
  var sec = document.getElementById('cm-resenas');
  if (!sec || sec.getAttribute('data-cm-listo')) return;
  sec.setAttribute('data-cm-listo', '1');
  var ES = sec.getAttribute('data-lang') === 'es';
  var N = parseInt(sec.getAttribute('data-n'), 10) || 0;
  var NOTA = sec.getAttribute('data-nota') || '';
  var T = ES ? {
    ver: 'Verificada', sabor: 'Sabor', leer: 'Leer más', menos: 'Leer menos', ant: '‹ Anterior', sig: 'Siguiente ›',
    pag: function (a, b) { return 'Página ' + a + ' de ' + b; }, cerrar: 'Cerrar', resenas: 'reseñas',
    pagina: 'Página', antA: 'Página anterior', sigA: 'Página siguiente', orig: '', trad: '', verFoto: 'Ver foto', verVideo: 'Ver video'
  } : {
    ver: 'Verified', sabor: 'Flavor', leer: 'Read more', menos: 'Show less', ant: '‹ Previous', sig: 'Next ›',
    pag: function (a, b) { return 'Page ' + a + ' of ' + b; }, cerrar: 'Close', resenas: 'reviews',
    pagina: 'Page', antA: 'Previous page', sigA: 'Next page', orig: 'Show original', trad: 'Show translation', verFoto: 'View photo', verVideo: 'Watch video'
  };
  var SABOR_ES = { vanilla: 'Vainilla', coffee: 'Café', chocolate: 'Chocolate', matcha: 'Matcha', 'passion fruit': 'Maracuyá', watermelon: 'Sandía', citrus: 'Cítrico', lemon: 'Limón', unflavored: 'Sin sabor', strawberry: 'Fresa' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sabor(r) {
    var f = ES ? r.f : (r.fe || r.f);
    if (!f || f.indexOf('/') > -1) return ''; /* «Unisex / Ungüento» del desodorante no es un sabor */
    if (ES) f = SABOR_ES[f.toLowerCase()] || f;
    return T.sabor + ': ' + f;
  }
  function estrellas(s, alto) {
    var w = Math.max(0, Math.min(5, s)) / 5 * 100;
    return '<span class="cm-est cm-est--' + alto + '" role="img" aria-label="' + s + ' / 5"><span style="width:' + w.toFixed(1) + '%"></span></span>';
  }
  function textoDe(r) { return (!ES && r.te) ? r.te : r.t; }

  /* ---------- datos ---------- */
  var feed = [];
  try { feed = JSON.parse((sec.querySelector('[data-cm-feed]') || {}).textContent || '[]'); } catch (e) { feed = []; }
  var lista = null;
  function unir(completa) {
    if (!completa || !completa.length) return feed.slice();
    var ids = {}; completa.forEach(function (r) { ids[r.i] = 1; });
    var nuevasM = [], nuevasT = [];
    feed.forEach(function (r) { if (!ids[r.i]) (r.m ? nuevasM : nuevasT).push(r); });
    var conM = completa.filter(function (r) { return r.m; }), sinM = completa.filter(function (r) { return !r.m; });
    return nuevasM.concat(conM, nuevasT, sinM);
  }

  /* ---------- tarjeta ---------- */
  function tarjeta(r, compacta) {
    /* La foto o el video se abren en grande al tocarlos (visor) */
    var foto = r.m ? '<button type="button" class="cm-res-foto' + (r.m[0] === 'v' ? ' cm-res-foto--video' : '') + '" data-cm-media="' + esc(r.i) + '" aria-label="' + (r.m[0] === 'v' ? T.verVideo : T.verFoto) + ' · ' + esc(r.a) + '"><img src="' + esc(r.m[1]) + '" alt="" loading="lazy" decoding="async" width="' + (compacta ? 64 : 96) + '" height="' + (compacta ? 64 : 128) + '"></button>' : '';
    var ver = r.v ? '<span class="cm-res-verif">' + T.ver + '</span>' : '';
    var sab = sabor(r);
    var txt = textoDe(r) || '';
    var orig = (!ES && r.te && r.t && r.te !== r.t) ? '<button type="button" class="cm-res-orig" data-cm-orig>' + T.orig + '</button>' : '';
    if (compacta) {
      return '<article class="cm-resv-item' + (r.m ? '' : ' cm-sin-foto') + '" data-i="' + esc(r.i) + '">' + foto +
        '<div class="cm-resv-txt"><div class="cm-resv-nom"><b translate="no" class="notranslate">' + esc(r.a) + '</b>' + ver + estrellas(r.s, 12) + '</div>' +
        (sab ? '<p class="cm-res-sabor">' + esc(sab) + '</p>' : '') +
        '<p class="cm-resv-cuerpo" data-cm-cuerpo>' + esc(txt) + '</p>' +
        '<button type="button" class="cm-resv-leer" data-cm-leer hidden>' + T.leer + '</button>' + orig + '</div></article>';
    }
    return '<article class="cm-res-item' + (r.m ? '' : ' cm-sin-foto') + '" data-i="' + esc(r.i) + '">' + foto +
      '<div class="cm-res-txt">' + estrellas(r.s, 14) + '<div class="cm-res-nom"><b translate="no" class="notranslate">' + esc(r.a) + '</b>' + ver + '</div>' +
      (sab ? '<p class="cm-res-sabor">' + esc(sab) + '</p>' : '') +
      '<p class="cm-res-cuerpo" data-cm-cuerpo>' + esc(txt) + '</p>' + orig + '</div></article>';
  }
  function activarOriginal(cont) {
    cont.addEventListener('click', function (e) {
      var fm = e.target.closest('[data-cm-media]'); if (fm) { verMedia(fm.getAttribute('data-cm-media'), fm); return; }
      var b = e.target.closest('[data-cm-orig]'); if (!b) return;
      var art = b.closest('[data-i]'); var r = (lista || feed).filter(function (x) { return x.i === art.getAttribute('data-i'); })[0]; if (!r) return;
      var p = art.querySelector('[data-cm-cuerpo]'); var vOrig = b.getAttribute('data-cm-estado') !== 'orig';
      p.textContent = vOrig ? r.t : r.te; b.textContent = vOrig ? T.trad : T.orig; b.setAttribute('data-cm-estado', vOrig ? 'orig' : 'trad');
      revisarLeer(art.parentNode);
    });
  }

  /* ---------- visor de fotos y videos ---------- */
  var PID = sec.getAttribute('data-pid'), visor = null, visorAbridor = null;
  function verMedia(id, boton) {
    var r = (lista || feed).filter(function (x) { return x.i === id; })[0]; if (!r || !r.m) return;
    visorAbridor = boton;
    if (!visor) {
      visor = document.createElement('div'); visor.className = 'cm-visor'; visor.setAttribute('hidden', '');
      visor.innerHTML = '<div class="cm-visor-fondo" data-cm-vcerrar></div><div class="cm-visor-caja" role="dialog" aria-modal="true" aria-label="' + T.verFoto + '"><button type="button" class="cm-visor-x" data-cm-vcerrar aria-label="' + T.cerrar + '">✕</button><div class="cm-visor-media" data-cm-vmedia></div></div>';
      document.body.appendChild(visor);
      visor.addEventListener('click', function (e) { if (e.target.closest('[data-cm-vcerrar]')) cerrarVisor(); });
    }
    var m = visor.querySelector('[data-cm-vmedia]');
    if (r.m[0] === 'v') {
      /* Video: el reproductor de Cloudflare Stream que usa Loox; si no tenemos el id, la vista rápida de Loox */
      var src = r.m[2] ? 'https://iframe.videodelivery.net/' + r.m[2] + '?autoplay=true&muted=false&preload=auto'
        : 'https://loox.io/post/quickview/' + encodeURIComponent(r.i) + '?p=' + PID + '&language=' + (ES ? 'es' : 'en') + '&ref=inline&thumbnails=false';
      m.className = 'cm-visor-media cm-visor-media--video';
      m.innerHTML = '<iframe src="' + src + '" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowfullscreen title="' + T.verVideo + '"></iframe>';
    } else {
      m.className = 'cm-visor-media';
      m.innerHTML = '<img src="' + esc(r.m[1].replace(/\.jpg(\?.*)?$/, '_mid.jpg')) + '" alt="' + esc(r.a) + '">';
    }
    bloquear(true, 'cm-visor-abierto');
    visor.removeAttribute('hidden');
    requestAnimationFrame(function () { var x = visor.querySelector('.cm-visor-x'); x && x.focus({ preventScroll: true }); });
  }
  function cerrarVisor() {
    if (!visor || visor.hasAttribute('hidden')) return false;
    visor.setAttribute('hidden', ''); visor.querySelector('[data-cm-vmedia]').innerHTML = '';
    bloquear(false, 'cm-visor-abierto');
    if (visorAbridor) visorAbridor.focus({ preventScroll: true });
    return true;
  }
  /* Bloqueo del desplazamiento del fondo sin moverlo de lugar (3-nov: fijar el body con top negativo no sirve en este
     tema: una regla del tema fuerza top:0 y el fondo saltaba al inicio de la página). */
  function bloquear(si, clase) {
    document.documentElement.classList.toggle(clase, si);
    var alguno = document.documentElement.classList.contains('cm-resv-abierta') || document.documentElement.classList.contains('cm-visor-abierto');
    document.documentElement.classList.toggle('cm-sin-scroll', alguno);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cerrarVisor()) e.stopImmediatePropagation(); }, true);

  /* ---------- números de página ---------- */
  function numeros(act, tot) {
    if (tot <= 6) { var a = []; for (var i = 1; i <= tot; i++) a.push(i); return a; }
    if (act <= 3) return [1, 2, 3, '…', tot];
    if (act >= tot - 2) return [1, '…', tot - 2, tot - 1, tot];
    return [1, '…', act, '…', tot];
  }

  /* ---------- bloque en la página: 3 por página ---------- */
  var cont = sec.querySelector('[data-cm-lista]'), nav = sec.querySelector('[data-cm-pag]'), POR = 3, pagB = 1;
  function pintarBloque(p, mover) {
    var l = lista || feed, tot = Math.max(1, Math.ceil(l.length / POR));
    pagB = Math.min(Math.max(1, p), tot);
    var h = ''; l.slice((pagB - 1) * POR, pagB * POR).forEach(function (r) { h += tarjeta(r, false); });
    cont.innerHTML = h;
    var nh = '<button type="button" class="cm-pg cm-pg--flecha" data-pg="' + (pagB - 1) + '" aria-label="' + T.antA + '"' + (pagB === 1 ? ' disabled' : '') + '>‹</button>';
    numeros(pagB, tot).forEach(function (n) {
      nh += n === '…' ? '<span class="cm-pg cm-pg--mas" aria-hidden="true">…</span>' :
        '<button type="button" class="cm-pg' + (n === pagB ? ' is-activa' : '') + '" data-pg="' + n + '" aria-label="' + T.pagina + ' ' + n + '"' + (n === pagB ? ' aria-current="page"' : '') + '>' + n + '</button>';
    });
    nh += '<button type="button" class="cm-pg cm-pg--flecha" data-pg="' + (pagB + 1) + '" aria-label="' + T.sigA + '"' + (pagB === tot ? ' disabled' : '') + '>›</button>';
    nav.innerHTML = tot > 1 ? nh : '';
    sec.classList.add('cm-res--lista');
    if (mover) { var top = cont.getBoundingClientRect().top; if (top < 0) window.scrollBy(0, top - 24); }
  }
  nav.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pg]'); if (!b || b.disabled) return;
    pintarBloque(parseInt(b.getAttribute('data-pg'), 10), true);
  });
  activarOriginal(cont);

  /* ---------- ventana: 5 por página ---------- */
  var ven = null, pagV = 1, abridor = null;
  function crearVentana() {
    ven = document.createElement('div');
    ven.className = 'cm-resv'; ven.setAttribute('hidden', '');
    ven.innerHTML = '<div class="cm-resv-fondo" data-cm-cerrar></div>' +
      '<div class="cm-resv-caja" role="dialog" aria-modal="true" aria-labelledby="cm-resv-tit">' +
      '<div class="cm-resv-cab"><p id="cm-resv-tit" translate="no">' + N + ' ' + T.resenas + ' · ' + NOTA + ' ★</p>' +
      '<button type="button" class="cm-resv-x" data-cm-cerrar aria-label="' + T.cerrar + '">✕</button></div>' +
      '<div class="cm-resv-lista" data-cm-vlista></div>' +
      '<div class="cm-resv-pie"><button type="button" class="cm-resv-btn" data-cm-v="-1">' + T.ant + '</button>' +
      '<span data-cm-vpag></span><button type="button" class="cm-resv-btn cm-resv-btn--sig" data-cm-v="1">' + T.sig + '</button></div></div>';
    document.body.appendChild(ven);
    ven.addEventListener('click', function (e) {
      if (e.target.closest('[data-cm-cerrar]')) { cerrar(); return; }
      var b = e.target.closest('[data-cm-v]'); if (b && !b.disabled) { pintarVentana(pagV + parseInt(b.getAttribute('data-cm-v'), 10)); return; }
      var l = e.target.closest('[data-cm-leer]');
      if (l) { var it = l.closest('.cm-resv-item'); var ab = it.classList.toggle('is-abierta'); l.textContent = ab ? T.menos : T.leer; }
    });
    activarOriginal(ven.querySelector('[data-cm-vlista]'));
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ven && !ven.hasAttribute('hidden')) cerrar(); });
  }
  function revisarLeer(c) {
    [].forEach.call(c.querySelectorAll('.cm-resv-item'), function (it) {
      var p = it.querySelector('[data-cm-cuerpo]'), b = it.querySelector('[data-cm-leer]'); if (!p || !b) return;
      if (it.classList.contains('is-abierta')) return;
      b.hidden = !(p.scrollHeight > p.clientHeight + 2);
    });
  }
  function pintarVentana(p) {
    var l = lista || feed, tot = Math.max(1, Math.ceil(l.length / 5));
    pagV = Math.min(Math.max(1, p), tot);
    var vl = ven.querySelector('[data-cm-vlista]'), h = '';
    l.slice((pagV - 1) * 5, pagV * 5).forEach(function (r) { h += tarjeta(r, true); });
    vl.innerHTML = h; vl.scrollTop = 0;
    ven.querySelector('[data-cm-vpag]').textContent = T.pag(pagV, tot);
    var bs = ven.querySelectorAll('[data-cm-v]'); bs[0].disabled = pagV === 1; bs[1].disabled = pagV === tot;
    requestAnimationFrame(function () { revisarLeer(vl); });
  }
  function abrir(e) {
    abridor = e && e.currentTarget;
    if (!ven) crearVentana();
    cargar();
    pintarVentana(1);
    bloquear(true, 'cm-resv-abierta');
    ven.removeAttribute('hidden');
    requestAnimationFrame(function () { ven.classList.add('is-visible'); var x = ven.querySelector('.cm-resv-x'); x && x.focus({ preventScroll: true }); });
  }
  function cerrar() {
    ven.classList.remove('is-visible');
    ven.setAttribute('hidden', '');
    bloquear(false, 'cm-resv-abierta');
    if (abridor) abridor.focus({ preventScroll: true });
  }
  sec.querySelector('[data-cm-ver]').addEventListener('click', abrir);

  /* ---------- carga del archivo completo ---------- */
  var pedido = null;
  function cargar() {
    if (pedido) return pedido;
    var src = sec.getAttribute('data-src');
    pedido = fetch(src, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { lista = unir(d && d.r); })
      .catch(function () { lista = feed.slice(); })
      .then(function () {
        pintarBloque(pagB, false);
        if (ven && !ven.hasAttribute('hidden')) pintarVentana(pagV);
      });
    return pedido;
  }
  /* El bloque se pinta con la lista completa (orden de Loox). Se pide cuando el bloque se acerca a la pantalla o al
     terminar de cargar la página; si el archivo no responde en 3 s, se pinta con las de review_feed. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); cargar(); } }, { rootMargin: '1500px 0px' });
    io.observe(sec);
  }
  window.addEventListener('load', function () { setTimeout(cargar, 800); });
  setTimeout(function () { if (!lista) pintarBloque(1, false); }, 3000);
})();
